export const init = async function() {
    const variantSelectorDummy = document.querySelector('.js-variant-selector-dummy');
    if (variantSelectorDummy) {
        const notifyMeBtn = document.getElementById('notify-me-btn');
        if (!notifyMeBtn) {
            console.error('Notify Me button not found');
            return;
        }
        notifyMeBtn.addEventListener('click', function(event) {
            var _document_querySelector;
            event.preventDefault();
            const variantId = variantSelectorDummy.getAttribute('value');
            const productJson = (_document_querySelector = document.querySelector('.js-product-details')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getAttribute('data-product-json');
            const productData = productJson ? JSON.parse(productJson) : null;
            if (!variantId || !productData) {
                console.error('Variant ID or Product ID not found');
                return;
            }
            window._RestockRocket.openModal(productData, parseInt(variantId));
            // The following logic is a workaround to prevent the body from scrolling
            // when the Stoq modal is open. We need to ensure that the body is frozen
            // when the modal is open.
            // Also, we need to ensure that the body is unfrozen when the modal is closed.
            // The modal can be closed by clicking the close button or the wrapper (overlay)
            // around the modal. We need to add event listeners to both of these elements.
            const body = document.querySelector('body');
            if (body) {
                body.classList.add('is-frozen');
            }
            // #restock-rocket is initially empty, so we need to wait for it
            // to be populated before we can observe the close button and the overlay(restock-rocket-wrapper)
            // and remvove 'is-frozen' from the body when either of them is clicked.
            const target = document.getElementById('restock-rocket');
            if (target) {
                const observer = new MutationObserver((mutations, obs)=>{
                    const closeButton = target.querySelector('#formContainer-Close');
                    const wrapper = target.querySelector('.restock-rocket-wrapper');
                    if (closeButton && wrapper) {
                        const unfreeze = ()=>{
                            body === null || body === void 0 ? void 0 : body.classList.remove('is-frozen');
                        };
                        closeButton.addEventListener('click', unfreeze);
                        wrapper.addEventListener('click', unfreeze);
                        obs.disconnect() // Stop observing once both elements are found
                        ;
                    }
                });
                observer.observe(target, {
                    childList: true,
                    subtree: true
                });
            }
        });
    }
};
